export interface BatchCallItem<T, U> {
  method: (args: U) => Promise<T>;
  args: U;
}

export type BatchCall<T, U> = Array<BatchCallItem<T, U>>;

export const callBatch = async <T, U>(calls: BatchCall<T, U>) => {
  const results: T[] = [];
  for (const { method, args } of calls) {
    try {
      const result = await method(args);
      results.push(result);
    } catch (error) {
      results.push(error as T);
    }
  }
  return results;
};
